<template>
  <div class="login-container">
    <b-row class="w-100 h-100 m-0 overflow-hidden">
      <b-col
        sm="12"
        md="6"
        class="left-column bg--white d-flex flex-column align-items-center justify-content-center"
      >
        <div class="d-flex flex-column align-items-center header-container">
          <img
            src="@/assets/imgs/logos/hr-logo-color.png"
            alt="Public Support logo"
            class="logo-image"
          />
          <h2 class="font-md mt-5 font-family-medium">
            Login
          </h2>
        </div>
        <ValidationObserver ref="observer">
          <b-form
            @submit.prevent="authenticate"
            @keyup.enter.prevent="authenticate"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <div
                v-if="showError"
                class="mt-3"
                :style="{ 'text-align': 'center' }"
              >
                <li
                  v-for="error in errors"
                  :key="error.message"
                  class="top-error-message"
                >
                  <h6
                    class="font-sm font-family-regular danger position-relative mb-3 error-1"
                  >
                    {{ error }}
                  </h6>
                </li>
              </div>
              <ValidationProvider
                v-if="!isProduction"
                name="Email"
                rules="email|required"
                v-slot="{ errors }"
              >
                <b-form-input
                  autocomplete="off"
                  :class="{ 'form-input-one': true, invalid: errors[0] }"
                  size="lg"
                  type="text"
                  placeholder="Email"
                  v-model="email"
                ></b-form-input>
                <h6
                  v-if="errors[0]"
                  data-testid="email-errors"
                  class="font-sm email-error font-family-regular danger position-relative error-3"
                >
                  {{ errors[0] }}
                </h6>
              </ValidationProvider>
              <ValidationProvider
                v-if="!isProduction"
                name="password"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  :class="{ 'form-input-two': true, invalid: errors[0] }"
                  size="lg"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                ></b-form-input>
                <h6
                  v-if="errors[0]"
                  data-testid="password-errors"
                  class="font-sm password-error danger position-relative font-family-regular error-2"
                >
                  {{ errors[0] }}
                </h6>
              </ValidationProvider>
              <p
                v-if="!isProduction"
                @click="$router.push({ name: 'ForgotPassword' })"
                class="forgot-password-link text-center mb-4 mt-5 cursor-pointer primary--text font-family-medium"
              >
                Forgot Password?
              </p>

              <div
                class="d-flex align-items-center flex-column"
                :style="{ width: '100%' }"
              >
                <b-button
                  v-if="!isProduction"
                  class="login-btn btn-A mt-4 mb-5 btn-pill"
                  block
                  @click.prevent="authenticate"
                >
                  <b-spinner
                    style="width: 14px; height: 14px"
                    v-if="emailLoading"
                    variant="light"
                    label="Spinning"
                  ></b-spinner>
                  {{ `${!emailLoading ? "Login" : ""}` }}
                </b-button>
                <b-avatar
                  v-if="!isProduction"
                  class="or-avatar primary-light align-items-center border-primary-lighter"
                  size="3.9rem"
                  text="OR"
                >
                  <!-- <p>OR</p> -->
                </b-avatar>

                <!-- <div
                  class="flex-row d-flex flex-wrap align-content-start w-80 mt-3 google-error-wrapper"
                  v-if="showGError"
                >
                  <li v-for="error in errors" :key="error.message">
                    <h6
                      class="font-sm font-family-regular danger position-relative mb-3 error-1"
                    >
                      {{ error }}
                    </h6>
                  </li>
                </div>
                <div
                  class="d-flex btn-google-sign-in cursor-pointer"
                  @click="loginWithGoogle"
                >
                  <div
                    class="btn-icon-left-container d-flex justify-content-center align-items-center"
                  >
                    <img
                      class="icon-google"
                      src="@/assets/icons/icon_google.svg"
                      alt
                    />
                  </div>
                  <div
                    class="btn-main-content position-relative d-flex justify-content-center align-items-center"
                  >
                    <h6
                      class="font-sm position-relative btn-main-content-text button--text-dark"
                    >
                      Continue with Google
                    </h6>
                    <img
                      class="icon-arrow-right"
                      src="@/assets/icons/arrow_right.svg"
                      alt
                    />
                  </div>
                </div> -->
              </div>
              <div
                class="d-flex btn-microsoft-sign-in cursor-pointer mt-3"
                @click="loginWithMicrosoft"
              >
                <div
                  class="btn-icon-left-container d-flex justify-content-center align-items-center"
                >
                  <img
                    class="icon-microsoft"
                    src="@/assets/icons/microsoft_logo.svg"
                    alt
                    style="width:13px; height:13px"
                  />
                </div>
                <div
                  class="btn-main-content position-relative d-flex justify-content-center align-items-center"
                >
                  <h6
                    class="font-sm position-relative btn-main-content-text button--text-dark"
                  >
                    Continue with Microsoft
                  </h6>
                  <img
                    class="icon-arrow-right"
                    src="@/assets/icons/arrow_right.svg"
                    alt
                  />
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </b-col>
      <b-col
        sm="6"
        md="6"
        class="right-column bg--primary-lighter position-relative"
      >
        <div
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <div class="banner-container">
            <img
              class="banner-image"
              src="@/assets/imgs/logos/banner_right_2x.png"
              alt
            />
          </div>
          <q class="font-family-regular primary-dark quote-class">{{
            quote.quote
          }}</q>
          <p class="banner-subtitle-text font-family-medium primary-dark">
            {{ quote.quotee }}
          </p>
          <!-- <div class="carousel-container d-flex">
            <span class="carousel-circle-dark-blue bg--primary"></span>
            <span class="carousel-circle-light-blue"></span>
            <span class="carousel-circle-light-blue"></span>
          </div> -->
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import { mapActions, mapState } from "vuex";
import { quotes } from "@/utils/quotes.js";
extend("email", {
  message: () => "Email is not valid"
});
extend("required", {
  message: () => "This is a required field"
});
export default {
  name: "Login",
  data() {
    return {
      showLoading: true,
      email: "",
      email2: "",
      password: "",
      showGError: "",
      emailLoading: false,
      msg: "",
      alertDuration: null,
      showAlert: false,
      showError: false,
      errors: [],
      gError: [],
      quotesArr: quotes,
      quote: {},
      role: ""
    };
  },
  computed: {
    ...mapState("authModule", ["previousRoute"]),
    isProduction() {
      return process.env.VUE_APP_SENTRY_ENABLED === "TRUE";
    }
  },
  methods: {
    getUserRoleAndNavigate() {
      const sentToken = localStorage.getItem("user-token");
      this.actionGetUserDetails()
        .then(res => {
          this.role = res.defaultProfile.role.name;
          if (this.role === "admin") {
            this.$router.push({ name: "ViewPADirectory" });
          } else if (this.role === "assistant") {
            this.$router.push({ name: "TaskDashboard" });
          } else if (this.role === "owner") {
            this.$router.push({ name: "DedicatedCustomers" });
          }
        })
        .catch(err => {
          console.log(err.response);
          // Stale/invalid stored token: drop it silently so the user can log in again.
          // Only if it's still the one we sent; a login may have replaced it meanwhile.
          if (err.response && err.response.status === 401) {
            if (localStorage.getItem("user-token") === sentToken) {
              localStorage.removeItem("user-token");
            }
            return;
          }
          this.showError = true;
          this.errors.push(err.response.data.detail);
        });
    },
    loginWithMicrosoft() {
      const url = process.env.VUE_APP_AZURE_LOGIN_URL;
      if (!url) {
        console.error("VUE_APP_AZURE_LOGIN_URL is missing");
        alert("Microsoft login is not configured");
        return;
      }
      window.location.href = url; // redirect to backend
    },
    async loginWithGoogle() {
      this.showError = false;
      this.showGError = false;
      this.errors.length = 0;
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          const data = {
            accessToken: GoogleUser.getAuthResponse().access_token,
            code: GoogleUser.getAuthResponse().id_token
          };
          this.signInWithGoogle(data)
            .then(() => {
              this.getUserRoleAndNavigate();
            })
            .catch(error => {
              this.showGError = true;
              if (error.response.status === 400) {
                this.errors = [...error.response.data.nonFieldErrors];
              } else {
                this.errors.push(error.response.data.detail);
              }
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    async authenticate() {
      const valid = await this.$refs.observer.validate();
      if (valid) {
        this.emailLoading = true;
        this.showError = false;
        this.showGError = false;
        this.errors.length = 0;
        {
          const data = {
            email: this.email,
            password: this.password
          };
          // Don't send a previous (possibly stale) token with the login request.
          localStorage.removeItem("user-token");
          this.actionAuthenticateUser(data)
            .then(() => {
              this.emailLoading = false;
              this.getUserRoleAndNavigate();
            })
            .catch(error => {
              this.showError = true;
              if (error.response.status === 400) {
                this.errors = [...error.response.data.nonFieldErrors];
              } else {
                this.errors.push(error.response.data.detail);
              }
              this.emailLoading = false;
            });
        }
      }
    },
    ...mapActions("authModule", [
      "actionAuthenticateUser",
      "actionGetUserDetails",
      "sendResetLink",
      "signInWithGoogle"
    ])
  },
  created() {
    let quoteIndex = Math.floor(Math.random() * this.quotesArr.length);
    this.quote = this.quotesArr[quoteIndex];
    if (localStorage.getItem("user-token")) {
      this.getUserRoleAndNavigate();
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables/colors.scss";

.right-column,
.left-column {
  min-height: 100vh;
}
.quote-class {
  font-size: 1.6rem;
  width: 58%;
  text-align: center;
  margin-bottom: 20px;
}
.action-btn-top {
  top: 2.5rem;
  right: 2.5rem;
}
.banner-container {
  margin-top: 15rem;
  margin-left: 6.5rem;
  margin-bottom: 2.66rem;
}
.banner-image {
  object-fit: cover;
  max-width: 438px;
}
.banner-subtitle-text {
  text-align: center;
  max-width: 47rem;
  white-space: break-spaces;
  font-size: 2.4rem;
}
.logo-image {
  width: 14rem;
}
.form-input-one,
.form-input-two {
  width: 35.2rem;
  border-radius: 4px;
  margin: 1rem 0 1rem 0;
}
.form-input-one {
  margin-bottom: 3rem;
}
.login-btn {
  color: white;
  width: 20.8rem;
  max-width: 20.8rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  background: $button-secondary;
}
.btn-google-sign-in {
  margin-top: 3rem;
  margin-bottom: 4rem;
}
.icon-google {
  width: 13px;
  height: 13px;
}
.btn-icon-left-container {
  border: 1px solid #e0e0e0;
  border-radius: 2px 0px 0px 2px;
  width: 3.5rem;
  height: 3.5rem;
}
.btn-main-content {
  border: 1px solid #e0e0e0;
  border-left: none;
  border-radius: 0px 2px 2px 0px;
  width: 21rem;
}
.btn-main-content-text {
  top: 0.5rem;
  left: -1.2rem;
  margin-top: -0.2rem;
}
.icon-arrow-right {
  position: absolute;
  right: 1rem;
}
.header-subtitle {
  max-width: 36rem;
}
input.invalid {
  border-color: #f35a63 !important;
}
input.invalid.form-control:focus {
  box-shadow: none;
}
.top-error-message {
  color: #f35a63;
  text-align: center;
}
.left-column {
  > span {
    width: 100%;
  }
  .google-error-wrapper {
    justify-content: center;
  }
}
@media screen and (max-width: 1180px) {
  .banner-container {
    margin-left: 0;
  }
  .banner-image {
    max-width: 40vw;
  }
}
@media screen and (max-width: 876px) {
  .banner-image {
    max-width: 50vw;
  }
}
@media screen and (min-width: 576px) and (max-width: 876px) {
  .left-column,
  .right-column {
    max-width: 100%;
    flex: 0 0 100%;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .right-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (max-width: 600px) {
  .banner-image {
    max-width: 75vw;
  }
  .form-input-one,
  .form-input-two {
    width: 75vw;
  }
}
@media screen and (max-width: 413px) {
  .left-column,
  .right-column {
    height: auto;
  }
}
</style>
